import { BehaviorSubject } from 'rxjs';

export class RemoteMediaEventBus {
  static handleVideoPrivacy$ = new BehaviorSubject<string>('');
}
